// src/services/stockMoves.js
import { collection, doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../services/firebase";

export async function recordInventoryMove({
  itemId,
  locationId = "boutique",
  type,           // "reception" | "sale" | "adjust" | ...
  delta = 0,      // +10, -3, etc.
  countedQty = null,
  note = "",
  ref = null,     // id de PO, ticket de caisse, etc.
}) {
  const stockKey = `${locationId}__${itemId}`;
  const stockRef = doc(db, "stock", stockKey);
  const moveRef = doc(collection(db, "inventoryMoves"));

  await runTransaction(db, async (tx) => {
    const sSnap = await tx.get(stockRef);
    const oldQty = (sSnap.exists() ? sSnap.data().qty : 0) || 0;
    const newQty =
      countedQty !== null && countedQty !== undefined
        ? countedQty
        : oldQty + delta;

    // mise à jour du stock
    tx.set(
      stockRef,
      {
        itemId,
        locationId,
        qty: newQty,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    // mouvement
    tx.set(moveRef, {
      type,
      itemId,
      locationId,
      delta,
      countedQty: countedQty ?? null,
      at: serverTimestamp(),
      note,
      ref, // id du bon de commande, du ticket, etc.
    });
  });
}
